import React, { useState } from "react";
import "./Duvidas.css";

const items = [
  {
    pergunta: "Quantas etapas?",
    resposta: `Reunião ou conversa online / telefone, para entendermos sobre o seu negócio.
Assinatura do contrato e pagamento.
Montagem do layout/protótipo inicial.
Desenvolvimento do site.
Revisão e ajustes / criação do domínio.
Pagamento do valor restante.
Criação do perfil no Google Meu Negócio.`,
  },
  {
    pergunta: "O que é SEO?",
    resposta:
      "SEO é um conjunto de técnicas para otimizar um site e melhorar seu posicionamento nos buscadores, aumentando a visibilidade e atraindo mais visitantes.",
  },
  {
    pergunta: "Qual o prazo de entrega?",
    resposta:
      "O prazo de entrega varia entre cada projeto dependendo da sua complexidade, porque cada projeto é único. O prazo fica em torno de 25 dias úteis.",
  },
  {
    pergunta: "O que seria COPY?",
    resposta:
      "Copy de uma empresa é o conteúdo escrito usado para promover e vender produtos ou serviços. Ele inclui textos de anúncios, sites, e-mails e redes sociais, com o objetivo de atrair, engajar e convencer o público a tomar uma ação.",
  },
  {
    pergunta: "O que é um certificado SSL?",
    resposta:
      "O certificado SSL garante a segurança da comunicação entre o site e seus visitantes, criptografando dados sensíveis como senhas e informações de pagamento.",
  },
  {
    pergunta: "Quantas alterações posso fazer?",
    resposta:
      "Você pode fazer duas alterações em seu projeto: na entrega do layout e na reunião de revisão final.",
  },
  {
    pergunta: "Quais são as formas de pagamento?",
    resposta:
      "Pix, débito, dinheiro, ou cartão com taxa da maquininha. Parcelamento até 10x.",
  },
  {
    pergunta: "O que é domínio e hospedagem?",
    resposta:
      "O domínio é o endereço do site. A hospedagem (como Vercel) garante velocidade, segurança e estabilidade.",
  },
];

export default function Duvidas() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  return (
    <section className="duvidas-section" id="duvidas">
      <h1 className="duvidas-title">Dúvidas Frequentes</h1>

      <div className="duvidas-grid">
        {items.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div className="faq-item" key={index}>
              <button
                className={`faq-question ${isOpen ? "open" : ""}`}
                onClick={() => toggle(index)}
              >
                <span>{item.pergunta}</span>
                <span className="faq-icon">{isOpen ? "−" : "+"}</span>
              </button>

              <div className={`faq-answer-wrapper ${isOpen ? "open" : ""}`}>
                <div className="faq-answer">
                  {item.resposta.split("\n").map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
